import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { TaxReturn, TaxReturnCreate, TaxReturnFilter } from '../data/taxReturn';

export function createTaxReturnService(client: AxiosInstance) {
  return createCrudService<TaxReturn, TaxReturnCreate, TaxReturnFilter>(
    client,
    '/accounting/TaxReturn',
    'id',
  );
}

export type TaxReturnService = CrudService<TaxReturn, TaxReturnCreate, TaxReturnFilter>;
